import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7887
 *
 * @param {SvgIconProps} props - svg props
 */
export const VideoConferenceIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M3 3.5C2.44772 3.5 2 3.94772 2 4.5V16.5C2 17.0523 2.44772 17.5 3 17.5H21C21.5523 17.5 22 17.0523 22 16.5V4.5C22 3.94772 21.5523 3.5 21 3.5H3ZM3.5 5.5C3.22386 5.5 3 5.72386 3 6V15C3 15.2761 3.22386 15.5 3.5 15.5H20.5C20.7761 15.5 21 15.2761 21 15V6C21 5.72386 20.7761 5.5 20.5 5.5H3.5Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M17.9999 17.5C17.9999 17.5 13.4999 17.5 13.4999 18.5C13.4999 19.0523 13.9999 19.5 13.9999 19.5H16.7499C16.888 19.5 16.9999 19.6119 16.9999 19.75V20.5C16.9999 20.6381 16.888 20.75 16.7499 20.75H7.24989C7.11182 20.75 6.99989 20.6381 6.99989 20.5V19.75C6.99989 19.6119 7.11182 19.5 7.24989 19.5H9.99989C9.99989 19.5 10.4999 19.0523 10.4999 18.5C10.4999 17.5 14.9999 17.5 14.9999 17.5C-14.9787 17.5 34.1112 17.5 17.9999 17.5Z' fill={color}/>
        </SvgIcon>
    )
}

export default VideoConferenceIcon
